import { render, staticRenderFns } from "./DecidedPhds.vue?vue&type=template&id=33c58afe&scoped=true&"
import script from "./DecidedPhds.vue?vue&type=script&lang=js&"
export * from "./DecidedPhds.vue?vue&type=script&lang=js&"
import style0 from "./DecidedPhds.vue?vue&type=style&index=0&id=33c58afe&prod&lang=css&"
import style1 from "./DecidedPhds.vue?vue&type=style&index=1&id=33c58afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c58afe",
  null
  
)

export default component.exports